import albumInvitesPage from 'Media/js/page/media.album.my.invites';
import ebooksPage from './js/page/user-view-ebooks';
import eventsPage from './js/page/user-view-events';
import groupsPage from './js/page/user-view-groups';
import profileFollow from './js/page/user-view-follow';
import profileNotesPage from './js/page/profile-notes';
import profilePage from './js/page/user-view';
import profileStatus from './js/page/user-view-status';
import profileVouches from './js/page/profile-vouches';
import storiesPage from './js/page/user-view-stories';

export default {
    'media-album-my-invites': albumInvitesPage,
    'profiles-notes': profileNotesPage,
    'reputation-vouches': profileVouches,
    'user-view-statuses': profilePage,
    'user-view-status': profileStatus,
    'user-view': profilePage,
    'user-view-addys': profilePage,
    'user-view-ebooks': ebooksPage,
    'user-view-events': eventsPage,
    'user-view-followers': profileFollow,
    'user-view-following': profileFollow,
    'user-view-friends': profilePage,
    'user-view-groups': groupsPage,
    'user-view-photos': profilePage,
    'user-view-photos-album': profilePage,
    'user-view-photos-upload': profilePage,
    'user-view-stories': storiesPage
};
